var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isTop),expression:"isTop"}],staticClass:"liquor-sticky",on:{"click":_vm.onClick}},[_c('img',{attrs:{"src":"/liquor/置顶.png"}})])}
var staticRenderFns = []

export { render, staticRenderFns }